import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { StoreService } from '../../../../store-configuration/store.service';
import { SellingPlatform } from '@models/configuration/marketplace/marketplace-model';

@Component({
  selector: 'app-search-selling-platform',
  templateUrl: './search-selling-platform.component.html',
  styleUrls: ['./search-selling-platform.component.scss'],
})
export class SearchSellingPlatformComponent implements OnInit {
  @Output()
  selectedPlatform = new EventEmitter<string>();

  currentSelectedPlatform: string;

  sellingPlatforms: SellingPlatform[];

  constructor(private storeService: StoreService) {}

  ngOnInit(): void {
    this.storeService.getSellingPlatforms().subscribe((r) => (this.sellingPlatforms = r));
  }

  selectedSellingPlatform(p: SellingPlatform) {
    this.selectedPlatform.emit(p.name);
    this.currentSelectedPlatform = p.name;
  }
}
